import React from 'react';
import { AwardIcon, UsersIcon } from 'lucide-react';
export function Faculty() {
  return <section className="py-24" data-id="element-124">
      <div className="max-w-7xl mx-auto px-6" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-127">
            Faculty & Partners
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-128">
            Learn from professors and practitioners who teach at the world's top
            institutions and build AI-native products
          </p>
        </div>

        {/* Faculty description */}
        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-129">
          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8" data-id="element-130">
            <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-purple-500 rounded-lg flex items-center justify-center mb-6" data-id="element-131">
              <AwardIcon className="w-7 h-7 text-white" data-id="element-132" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-133">
              World-Class Faculty
            </h3>
            <p className="text-slate-300 mb-4" data-id="element-134">
              Our faculty includes professors and practitioners from:
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-135">
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-136">
                Stanford
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-137">
                Wharton
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-138">
                INSEAD
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-139">
                Ivey Business School
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-140">
                MIT
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-141">
                Waterloo
              </span>
              <span className="px-3 py-1 bg-slate-700/50 rounded-full text-sm text-slate-300" data-id="element-142">
                NUS
              </span>
            </div>
            <p className="text-slate-400 mt-6 text-sm" data-id="element-143">
              These aren't just academics—they're practitioners who have built
              AI-native products, advised Fortune 500 companies, and worked with
              leading AI labs.
            </p>
          </div>

          <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-8" data-id="element-144">
            <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mb-6" data-id="element-145">
              <UsersIcon className="w-7 h-7 text-white" data-id="element-146" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-147">
              AI Lab Connections
            </h3>
            <p className="text-slate-300 mb-4" data-id="element-148">
              Team members who have worked with Dr. Geoffrey Hinton (the
              "godfather of AI") and leading AI research labs bring cutting-edge
              insights directly to you.
            </p>
            <p className="text-slate-400 text-sm" data-id="element-149">
              This isn't theory from textbooks—it's real-world AI knowledge from
              people building the future.
            </p>
          </div>
        </div>

        {/* AI Partners */}
        <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 border border-slate-700 rounded-2xl p-12" data-id="element-150">
          <h3 className="text-3xl font-bold text-white mb-6 text-center" data-id="element-151">
            Direct Access to Enterprise AI Tools
          </h3>
          <p className="text-xl text-slate-300 text-center mb-8 max-w-3xl mx-auto" data-id="element-152">
            We work directly with leading AI platforms and enterprise partners
            to give you hands-on experience with the tools that matter.
          </p>

          <div className="flex flex-wrap justify-center gap-8 mb-6" data-id="element-153">
            <div className="text-center" data-id="element-154">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-155">OpenAI</div>
              <div className="text-sm text-slate-400" data-id="element-156">GPT-4, DALL-E</div>
            </div>
            <div className="text-center" data-id="element-157">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-158">
                Perplexity
              </div>
              <div className="text-sm text-slate-400" data-id="element-159">Research AI</div>
            </div>
            <div className="text-center" data-id="element-160">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-161">Claude</div>
              <div className="text-sm text-slate-400" data-id="element-162">Anthropic</div>
            </div>
            <div className="text-center" data-id="element-163">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-164">Google</div>
              <div className="text-sm text-slate-400" data-id="element-165">Gemini, Vertex AI</div>
            </div>
            <div className="text-center" data-id="element-166">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-167">
                Microsoft
              </div>
              <div className="text-sm text-slate-400" data-id="element-168">Azure AI</div>
            </div>
            <div className="text-center" data-id="element-169">
              <div className="text-2xl font-bold text-white mb-1" data-id="element-170">Cohere</div>
              <div className="text-sm text-slate-400" data-id="element-171">Canadian AI Leader</div>
            </div>
          </div>

          <p className="text-sm text-slate-500 text-center" data-id="element-172">
            Partnerships vary by cohort. All participants get hands-on access to
            multiple enterprise AI platforms.
          </p>
        </div>
      </div>
    </section>;
}